import { register } from '../component.js';
import 'react';

var _socialIcons_twitch = register("twitch", {"color":"#6441A5","path":"M0 0v64h64V0zm47 35.8-7.6 7.6h-5.7l-3.8 3.8H26v-3.8h-7V23.1l1.9-5.1H47zm-17.8 7L33 39h7l4.5-4.5v-14h-21V39h5.7zm8.3-17.2H40v7.6h-2.5zm-7 0H33v7.6h-2.5z"});

export { _socialIcons_twitch as default };
